

























import {
computed,
defineComponent, ref, useContext, useFetch, useRoute,
} from '@nuxtjs/composition-api';
import { SfBreadcrumbs, SfIcon, SfLink } from '@storefront-ui/vue';
import { useUiHelpers } from '~/composables';
import { Routes, searchTermQueryParameter } from '~/helpers/routes';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import { Breadcrumb } from '~/modules/catalog/types';

enum EnumBreadcrumbVariant {
  SEARCH = 'search',
  HOME = 'home',
  CATEGORY = 'category',
}

export default defineComponent({
  components: { SfBreadcrumbs, SfLink, SfIcon },
  setup() {
    const { getCatLink } = useUiHelpers();
    const { localePath } = useContext();
    const route = useRoute();

    const { categoryAncestors, isCategoryTreeLoaded, loadCategoryTree } = useTraverseCategory();
    const breadcrumbs = ref<Breadcrumb[]>([]);

    const isSearching = computed(() => !!route.value.query.term);

    useFetch(async () => {
      if (!isCategoryTreeLoaded.value) {
        await loadCategoryTree();
      }

      breadcrumbs.value = [
        {
          text: 'Home',
          link: localePath('/'),
          variant: EnumBreadcrumbVariant.HOME,
        },
        ...categoryAncestors.value.map((category) => ({
          text: category.name,
          link: getCatLink(category),
          variant: EnumBreadcrumbVariant.CATEGORY,
        })),
      ];

      if (route.value.query[searchTermQueryParameter]?.length > 0) {
        breadcrumbs.value.push({
          text: `${String(route.value.query[searchTermQueryParameter])}`,
          link: localePath(`/${Routes.SEARCH}`),
          variant: EnumBreadcrumbVariant.SEARCH,
        });
      }
    });

    return {
      breadcrumbs,
      isSearching,
      EnumBreadcrumbVariant,
    };
  },
});
